export const NetworkKPIFieldMapping = [
  {
    fieldName: 'originatorDelay',
    kpiName: 'gigatestNetworkQualityPacketDelayFromOriginator',
    dimensions: 'srcsiteresourceid,monitorid',
    unit: 'ms'
  },
  {
    fieldName: 'destinationDelay',
    kpiName: 'gigatestNetworkQualityPacketDelayFromDestination',
    dimensions: 'srcsiteresourceid,monitorid',
    unit: 'ms'
  },
  {
    fieldName: 'originatorJitter',
    kpiName: 'gigatestNetworkQualityPacketJitterFromOriginator',
    dimensions: 'srcsiteresourceid,monitorid',
    unit: 'ms'
  },
  {
    fieldName: 'destinationJitter',
    kpiName: 'gigatestNetworkQualityPacketJitterFromDestination',
    dimensions: 'srcsiteresourceid,monitorid',
    unit: 'ms'
  },
  {
    fieldName: 'originatorPacketLoss',
    kpiName: 'gigatestNetworkQualityPacketLossFromOriginator',
    dimensions: 'srcsiteresourceid,monitorid',
    unit: '%'
  },
  {
    fieldName: 'destinationPacketLoss',
    kpiName: 'gigatestNetworkQualityPacketLossFromDestination',
    dimensions: 'srcsiteresourceid,monitorid',
    unit: '%'
  }
];
